
(function() {
  var result = { translations: { "es-mx": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "es-mx": "static-7.909"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.909",
    "ar-eg": "static-7.909",
    "bg": "static-7.909",
    "bn": "static-7.909",
    "ca-es": "static-7.909",
    "cs": "static-7.909",
    "da": "static-7.909",
    "de": "static-7.909",
    "el": "static-7.909",
    "en-gb": "static-7.909",
    "en": "static-7.909",
    "es-mx": "static-7.909",
    "es": "static-7.909",
    "fi": "static-7.909",
    "fr-ca": "static-7.909",
    "fr": "static-7.909",
    "he-il": "static-7.909",
    "hr": "static-7.909",
    "hu": "static-7.909",
    "id": "static-7.909",
    "it": "static-7.909",
    "ja": "static-7.909",
    "ko": "static-7.909",
    "lt": "static-7.909",
    "ms": "static-7.909",
    "nl": "static-7.909",
    "no": "static-7.909",
    "pl": "static-7.909",
    "pt-br": "static-7.909",
    "pt-pt": "static-7.909",
    "ro": "static-7.909",
    "ru": "static-7.909",
    "sk": "static-7.909",
    "sl": "static-7.909",
    "sv": "static-7.909",
    "th": "static-7.909",
    "tl": "static-7.909",
    "tr": "static-7.909",
    "uk": "static-7.909",
    "vi": "static-7.909",
    "x-pseudo": "static-7.909",
    "zh-cn": "static-7.909",
    "zh-hk": "static-7.909",
    "zh-tw": "static-7.909"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es-mx', {version: 'static-7.909'}); }
})();


